import { Routes, RouterModule } from '@angular/router';
import { AccountFunnelsLayoutComponent } from './layout/account-funnels-layout.component';
import { AccountFunnelsListComponent } from './list/account-funnels-list.component';
import { AccountGroupsComponent } from './groups/account-groups.component';
import { AccountTimeTablesComponent } from './timetables/account-timetables.component';

const accountFunnelsRoutes: Routes = [
  // Account routes
  {
    path: '',
    //outlet: 'Funnels',
    component: AccountFunnelsLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      { path: 'list', component: AccountFunnelsListComponent },
      { path: 'groups', component: AccountGroupsComponent },
      { path: 'timetables', component: AccountTimeTablesComponent },
    ],
  },
];

export const AccountFunnelsRouting = RouterModule.forChild(
  accountFunnelsRoutes,
);
